export default __webpack_public_path__ + "static/media/OpenSans-Regular.17e98b9e.ttf";